import { del } from "../../../utils/axios-config";
import { ENROLLMENTS_DOCUMENTS } from "../../../utils/constants";

export const deleteEnrollmentDocument = async (data: {ids: string[]}) => await del<{ids: string[]}, boolean>(ENROLLMENTS_DOCUMENTS, data);